import styled, { keyframes } from 'styled-components';

import { useContent } from '../../content/load';

const scroll = keyframes`
  from { transform: translateX(0); }
  to   { transform: translateX(-50%); }
`;

const Rail = styled.div`
  position: relative;
  height: ${(p) => p.theme.layout.rail}px;
  overflow: hidden;
  background: ${(p) => p.theme.color.bg[1]};
  border-bottom: 1px solid ${(p) => p.theme.color.border.faint};
`;

const Track = styled.div`
  display: flex;
  width: max-content;
  animation: ${scroll} 60s linear infinite;
`;

const Item = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 0 ${(p) => p.theme.step[3]}px;
  height: ${(p) => p.theme.layout.rail}px;
  font-family: ${(p) => p.theme.font.mono};
  font-size: ${(p) => p.theme.step[1]}px;
  color: ${(p) => p.theme.color.text[1]};
  border-right: 1px solid ${(p) => p.theme.color.border.faint};
  white-space: nowrap;
`;

const Sym = styled.span`
  color: ${(p) => p.theme.color.text[0]};
  font-weight: 600;
`;

const Chg = styled.span<{ $dir: 'up' | 'down' | 'flat' }>`
  color: ${(p) =>
    p.$dir === 'up'
      ? p.theme.color.semantic.up
      : p.$dir === 'down'
        ? p.theme.color.semantic.down
        : p.theme.color.text[2]};
`;

export function TopTicker() {
  const { site } = useContent();
  const items = [...site.ticker, ...site.ticker];
  return (
    <Rail aria-label="market ticker">
      <Track>
        {items.map((it, i) => (
          <Item key={`${it.sym}-${i}`}>
            <Sym>{it.sym}</Sym>
            <span>{it.px}</span>
            <Chg $dir={it.dir}>{it.chg}</Chg>
          </Item>
        ))}
      </Track>
    </Rail>
  );
}
